"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = { class: "corporations-filter-toolbox-cont" };
const _hoisted_2 = { class: "corporations-filter-toolbox corporations-filter-toolbox--topmost" };
const _hoisted_3 = ["placeholder"];
const _hoisted_4 = { class: "corporations-filter" };
const _hoisted_5 = { class: "corporations-filter-toolbox-cont" };
const _hoisted_6 = { class: "corporations-filter-toolbox" };
const _hoisted_7 = ["onClick"];
const _hoisted_8 = ["onClick"];
const _hoisted_9 = ["onClick"];
const _hoisted_10 = { class: "form-checkbox" };
const _hoisted_11 = ["value"];
const vue_3 = require("vue");
const PopupPanel_vue_1 = __importDefault(require("../common/PopupPanel.vue"));
exports.default = (0, vue_1.defineComponent)({
    __name: 'ModuleItemFilter',
    props: {
        title: {},
        groups: {},
        itemsByGroup: {},
        selected: {}
    },
    emits: ["update:selected", "close"],
    setup(__props, { expose: __expose, emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const filterText = (0, vue_3.ref)('');
        const localSelected = (0, vue_3.ref)([...props.selected]);
        function allItems() {
            return props.groups.flatMap((g) => props.itemsByGroup[g.key] ?? []);
        }
        function getItemsByGroup(key) {
            if (key === 'All')
                return allItems();
            return (props.itemsByGroup[key] ?? []).slice();
        }
        function selectAll(key) {
            for (const item of getItemsByGroup(key)) {
                if (!localSelected.value.includes(item)) {
                    localSelected.value.push(item);
                }
            }
        }
        function removeFromSelection(item) {
            const idx = localSelected.value.indexOf(item);
            if (idx !== -1) {
                localSelected.value.splice(idx, 1);
            }
        }
        function selectNone(key) {
            for (const item of getItemsByGroup(key)) {
                removeFromSelection(item);
            }
        }
        function invertSelection(key) {
            for (const item of getItemsByGroup(key)) {
                if (localSelected.value.includes(item)) {
                    removeFromSelection(item);
                }
                else {
                    localSelected.value.push(item);
                }
            }
        }
        function watchSelect(key, enabled) {
            enabled ? selectAll(key) : selectNone(key);
        }
        function include(name) {
            const normalized = filterText.value.toLocaleUpperCase();
            return normalized.length === 0 || name.toLocaleUpperCase().includes(normalized);
        }
        function icon(module) {
            if (module === undefined)
                return undefined;
            let suffix = module;
            if (module === 'colonies')
                suffix = 'colony';
            if (module === 'moon')
                suffix = 'themoon';
            return `create-game-expansion-icon expansion-icon-${suffix}`;
        }
        function showGroup(key) {
            const items = props.itemsByGroup[key];
            return (items ?? []).length > 0;
        }
        (0, vue_3.watch)(localSelected, (value) => {
            emit('update:selected', [...value]);
        }, { deep: true });
        __expose({ watchSelect });
        return (_ctx, _cache) => {
            const _directive_i18n = (0, vue_2.resolveDirective)("i18n");
            return ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(PopupPanel_vue_1.default, {
                onClose: _cache[5] || (_cache[5] = ($event) => (_ctx.$emit('close')))
            }, {
                header: (0, vue_2.withCtx)(() => [
                    (0, vue_2.createElementVNode)("div", _hoisted_1, [
                        (0, vue_2.withDirectives)(((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("h2", null, [
                            (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)(__props.title), 1)
                        ])), [
                            [_directive_i18n]
                        ]),
                        (0, vue_2.createElementVNode)("div", _hoisted_2, [
                            (0, vue_2.withDirectives)(((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("a", {
                                href: "#",
                                onClick: _cache[0] || (_cache[0] = (0, vue_2.withModifiers)(($event) => (selectAll('All')), ["prevent"]))
                            }, [...(_cache[6] || (_cache[6] = [
                                    (0, vue_2.createTextVNode)("All*", -1)
                                ]))])), [
                                [_directive_i18n]
                            ]),
                            _cache[9] || (_cache[9] = (0, vue_2.createTextVNode)(" | ", -1)),
                            (0, vue_2.withDirectives)(((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("a", {
                                href: "#",
                                onClick: _cache[1] || (_cache[1] = (0, vue_2.withModifiers)(($event) => (selectNone('All')), ["prevent"]))
                            }, [...(_cache[7] || (_cache[7] = [
                                    (0, vue_2.createTextVNode)("None*", -1)
                                ]))])), [
                                [_directive_i18n]
                            ]),
                            _cache[10] || (_cache[10] = (0, vue_2.createTextVNode)(" | ", -1)),
                            (0, vue_2.withDirectives)(((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("a", {
                                href: "#",
                                onClick: _cache[2] || (_cache[2] = (0, vue_2.withModifiers)(($event) => (invertSelection('All')), ["prevent"]))
                            }, [...(_cache[8] || (_cache[8] = [
                                    (0, vue_2.createTextVNode)("Invert*", -1)
                                ]))])), [
                                [_directive_i18n]
                            ]),
                            (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                class: "filter",
                                placeholder: _ctx.$t('filter'),
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((filterText).value = $event))
                            }, null, 8, _hoisted_3), [
                                [vue_2.vModelText, filterText.value]
                            ])
                        ])
                    ])
                ]),
                default: (0, vue_2.withCtx)(() => [
                    (0, vue_2.createElementVNode)("div", null, [
                        (0, vue_2.createElementVNode)("div", _hoisted_4, [
                            ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(__props.groups, (group) => {
                                return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, null, [
                                    (showGroup(group.key))
                                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                                            class: "corporations-filter-group",
                                            key: group.key
                                        }, [
                                            (0, vue_2.createElementVNode)("div", _hoisted_5, [
                                                (0, vue_2.createElementVNode)("div", null, [
                                                    (0, vue_2.withDirectives)(((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", null, [
                                                        (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)(group.label), 1)
                                                    ])), [
                                                        [_directive_i18n]
                                                    ]),
                                                    _cache[11] || (_cache[11] = (0, vue_2.createTextVNode)("  ", -1)),
                                                    (0, vue_2.createElementVNode)("div", {
                                                        class: (0, vue_2.normalizeClass)(icon(group.key))
                                                    }, null, 2)
                                                ]),
                                                (0, vue_2.createElementVNode)("div", _hoisted_6, [
                                                    (0, vue_2.withDirectives)(((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("a", {
                                                        href: "#",
                                                        onClick: (0, vue_2.withModifiers)(($event) => (selectAll(group.key)), ["prevent"])
                                                    }, [...(_cache[12] || (_cache[12] = [
                                                            (0, vue_2.createTextVNode)("All", -1)
                                                        ]))], 8, _hoisted_7)), [
                                                        [_directive_i18n]
                                                    ]),
                                                    _cache[15] || (_cache[15] = (0, vue_2.createTextVNode)(" | ", -1)),
                                                    (0, vue_2.withDirectives)(((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("a", {
                                                        href: "#",
                                                        onClick: (0, vue_2.withModifiers)(($event) => (selectNone(group.key)), ["prevent"])
                                                    }, [...(_cache[13] || (_cache[13] = [
                                                            (0, vue_2.createTextVNode)("None", -1)
                                                        ]))], 8, _hoisted_8)), [
                                                        [_directive_i18n]
                                                    ]),
                                                    _cache[16] || (_cache[16] = (0, vue_2.createTextVNode)(" | ", -1)),
                                                    (0, vue_2.withDirectives)(((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("a", {
                                                        href: "#",
                                                        onClick: (0, vue_2.withModifiers)(($event) => (invertSelection(group.key)), ["prevent"])
                                                    }, [...(_cache[14] || (_cache[14] = [
                                                            (0, vue_2.createTextVNode)("Invert", -1)
                                                        ]))], 8, _hoisted_9)), [
                                                        [_directive_i18n]
                                                    ])
                                                ])
                                            ]),
                                            ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(__props.itemsByGroup[group.key], (item) => {
                                                return (0, vue_2.withDirectives)(((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", { key: item }, [
                                                    (0, vue_2.createElementVNode)("label", _hoisted_10, [
                                                        (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                                            type: "checkbox",
                                                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((localSelected).value = $event)),
                                                            value: item
                                                        }, null, 8, _hoisted_11), [
                                                            [vue_2.vModelCheckbox, localSelected.value]
                                                        ]),
                                                        _cache[17] || (_cache[17] = (0, vue_2.createElementVNode)("i", { class: "form-icon" }, null, -1)),
                                                        (0, vue_2.renderSlot)(_ctx.$slots, "item", {
                                                            itemName: item,
                                                            icon: icon
                                                        })
                                                    ])
                                                ])), [
                                                    [vue_2.vShow, include(item)]
                                                ]);
                                            }), 128))
                                        ]))
                                        : (0, vue_2.createCommentVNode)("", true)
                                ], 64));
                            }), 256))
                        ])
                    ])
                ]),
                _: 3
            }));
        };
    }
});
